
import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import SecondStep from "./FormSteps/SecondStep";
import Headernp from "./Partials/Headernp";
import FirstStep from "./FormSteps/FirstStep";
import ThirdStep from "./FormSteps/ThirdStep";
import FourthStep from "./FormSteps/FourthStep";
import { useFormik } from "formik";
import * as Yup from "yup"
import ProjectIcon2 from "assets/icons/ProjectIcon2.svg"
import ProjectIcon4 from "assets/icons/ProjectIcon4.svg"
import AeroplaneIcon from "assets/icons/ProjectIcon1.svg"
import HeartIcon from "assets/icons/HeartIcon.svg"
import ProjectIcon3 from "assets/icons/ProjectIcon3.svg"
import { useNavigate } from "react-router-dom";
import { useAddProjectMutation } from "store/slices/apis/projectApiSlice";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import dayjs from "dayjs";

const CreateProject = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [addProject] = useAddProjectMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const steps = 4;

  const stepFields = {
    0: ["projectName", "projectType", "TotalLand", "BuiltUpArea", "DelieveredArea", "LeasingPercentage", "projectIcon",],
    1: ["discription", "start_date", "end_date", "address_line_1", "city", "state", "country", "zipcode", "longitude", "latitude"],
    2: ["client_business_name", "contractor_business_name", "contractor_number", "currency_awarded", "awarded_cost", "currency_budget", "budgeted_cost", "currency_original_budget", "original_budgeted_cost"],
    3: ["project_manager_name", "project_manager_designation", "project_manager_email", "project_manager_phoneno",]
  };

  const iconList = [
    { name: "ProjectIcon2", src: ProjectIcon2 },
    { name: "ProjectIcon4", src: ProjectIcon4 },
    { name: "AeroplaneIcon", src: AeroplaneIcon },
    { name: "HeartIcon", src: HeartIcon },
    { name: "ProjectIcon3", src: ProjectIcon3 },
  ];


  const handleClick = () => {
    formik.validateForm().then((errors) => {
      const currentFields = stepFields[activeStep];
      const stepErrors = currentFields.filter((field) => errors[field]);

      if (stepErrors.length === 0) {
        if (activeStep === steps - 1) {

          console.log("Submitting form...");
          formik.submitForm();
        } else {

          setActiveStep(prev => prev + 1)
        }
      } else {
        const touchedFields = {};
        currentFields.forEach((f) => (touchedFields[f] = true));
        formik.setTouched({ ...formik.touched, ...touchedFields });
      }
    });
  }

  const handlePrevious = () => {
    setActiveStep(prev => prev - 1)
  }
  const handleCancelClick = () => {
    navigate(-1)
  }
  const openNotification = (msg, type = "error", duration = 6000) => {
    dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: { color: type, variant: "filled" },
        transition: "SlideUp",
      })
    );
    setTimeout(() => dispatch(closeSnackbar()), duration);
  };



  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [activeStep]);

  const formik = useFormik({
    initialValues: {
      projectName: "",
      projectType: "",
      projectStatus: "",
      TotalLand: "",
      BuiltUpArea: "",
      DelieveredArea: "",
      LeasingPercentage: "",
      projectIcon: iconList[0].name,
      discription: "",
      start_date: "",
      end_date: "",
      address_line_1: "",
      city: "",
      state: "",
      country: "India",
      zipcode: "",
      latitude: "",
      longitude: "",
      client_business_name: "",
      contractor_business_name: "",
      contractor_number: "",
      currency_budget: "INR",
      budgeted_cost: "",
      currency_awarded: "INR",
      awarded_cost: "",
      currency_original_budget: "INR",
      original_budgeted_cost: "",
      project_manager_name: "",
      project_manager_designation: "",
      project_manager_email: "",
      country_code: "+91",
      project_manager_phoneno: "",
      project_image: ""
    },

    validationSchema: Yup.object({
      projectName: Yup.string()
        .required("Project name is required")
        .max(100, "Project name must be at most 100 characters"),

      projectType: Yup.string()
        .required("Project type is required"),

      projectStatus: Yup.string()
        .required("Project Status is required"),

      projectIcon: Yup.string()
        .required("Project Icon is required")
        .max(100, "Project Icon must be at most 100 characters"),

      discription: Yup.string()
        .required("Description is required")
        .max(500, "Description can’t exceed 500 characters"),

      start_date: Yup.date()
        .required("Start date is required")
        .typeError("Start date must be a valid date"),

      end_date: Yup.date()
        .required("End date is required")
        .typeError("End date must be a valid date")
        .min(Yup.ref("start_date"), "End date cannot be before start date"),

      address_line_1: Yup.string()
        .required("Address line 1 is required"),

      city: Yup.string()
        .required("City is required"),

      state: Yup.string()
        .required("State is required"),

      country: Yup.string()
        .required("Country is required"),

      zipcode: Yup.string()
        .required("Zipcode is required")
        .matches(/^[0-9]{5,6}$/, "Zipcode must be 5 or 6 digits"),

      latitude: Yup.string()
        .required("Latitude  required")
        .matches(/^[-+]?[0-9]*\.?[0-9]+$/, "Latitude must be a valid number"),

      longitude: Yup.string()
        .required("Longitude  required")
        .matches(/^[-+]?[0-9]*\.?[0-9]+$/, "Longitude must be a valid number"),

      client_business_name: Yup.string()
        .required("Client business name is required"),

      contractor_business_name: Yup.string()
        .required("Contractor business name is required"),

      contractor_number: Yup.string()
        .required("Contractor number is required")
        .matches(/^[0-9]{10}$/, "Contractor number must be 10 digits"),

      budgeted_cost: Yup.number()
        .typeError("Budgeted cost must be a number")
        .required("Budgeted cost is required")
        .positive("Budgeted cost must be positive"),

      awarded_cost: Yup.number()
        .typeError("Awarded cost must be a number")
        .required("Awarded cost is required")
        .positive("Awarded cost must be positive"),

      original_budgeted_cost: Yup.number()
        .typeError("Original Budgeted cost must be a number")
        .required("Original Budgeted cost is required")
        .positive("Original Budgeted cost must be positive"),

      project_manager_name: Yup.string()
        .required("Project manager name is required"),

      project_manager_designation: Yup.string()
        .required("Project manager designation is required"),

      project_manager_email: Yup.string()
        .email("Invalid email format")
        .required("Project manager email is required"),

      project_manager_phoneno: Yup.string()
        .required("Project manager phone number is required")
        .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),

      project_image: Yup.mixed()
        .nullable()
        .test("fileType", "Only image files are allowed", (value) => {
          if (!value) return true;
          if (value instanceof File) {
            return value.type.startsWith("image/");
          }
          if (typeof value === "string") {
            return /\.(png|jpg|jpeg|svg|webp|gif|bmp|tiff)$/i.test(value);
          }
          return false;
        }),

    }),

    onSubmit: (values, formikHelpers) => {
      console.log("projectDATA", values)
      handlSubmitForm(values)
      // formikHelpers.resetForm();
    },
  });

  const handlSubmitForm = async (values) => {
    const formData = new FormData();


    const convertToISO = (dateValue) => {
      if (!dateValue) return "";
      if (dayjs.isDayjs(dateValue)) {
        return dateValue.toISOString();
      }
      if (typeof dateValue === "string") {
        if (dateValue.includes('T')) return dateValue;
        return new Date(dateValue + 'T00:00:00.000Z').toISOString();
      }
      return "";
    };



    formData.append("ProjectName", values.projectName || "");
    formData.append("ProjectType", values.projectType || "");
    formData.append("ProjectIcon", values.projectIcon);
    formData.append("Status", values.projectStatus || "");
    formData.append("TotalLand", values.TotalLand || "");
    formData.append("BuiltUpArea", values.BuiltUpArea || "");
    formData.append("DelieveredArea", values.DelieveredArea || "");
    formData.append("LeasingPercentage", values.LeasingPercentage || "");
    formData.append("Description", values.discription || "");
    formData.append("ClientBusinessName", values.client_business_name || "");
    formData.append("ContractorBusinessName", values.contractor_business_name || "");
    formData.append("ContractorNumber", values.contractor_number || "");
    formData.append("AddressLine1", values.address_line_1 || "");
    formData.append("AddressLine2", "");
    formData.append("City", values.city || "");
    formData.append("State", values.state || "");
    formData.append("Country", values.country || "");
    formData.append("ZipCode", values.zipcode || "");
    formData.append("CurrencyBudget", values.currency_budget || "INR");
    formData.append("BudgetedCost", values.budgeted_cost || "");
    formData.append("ProjectManagerName", values.project_manager_name || "");
    formData.append("ProjectManagerEmail", values.project_manager_email || "");
    formData.append("ProjectManagerPhoneNo", values.project_manager_phoneno || "");
    formData.append("CountryCode", values.country_code || "+91");
    formData.append("AwardedCost", values.awarded_cost || "");
    formData.append("CurrencyAwarded", values.currency_awarded || "INR");
    formData.append("Latitude", values.latitude || "");
    formData.append("Longitude", values.longitude || "");
    formData.append("StartDate", convertToISO(values.start_date));
    formData.append("EndDate", convertToISO(values.end_date));
    formData.append("ProjectManagerDesignation", values.project_manager_designation || "");
    formData.append("OriginalBudget", values.original_budgeted_cost || "");
    formData.append("OriginalBudgetCurrency", values.currency_original_budget || "INR");

    if (values.project_image) {
      formData.append("ImageFile", values.project_image);
    }

    try {
      const res = await addProject(formData).unwrap();

      if (res.status === 'Success') {

        openNotification(res.message || "Project created successfully!", "success");
        navigate("/project-list");
      } else {

        openNotification(res.message || "Something went wrong while creating the project.", "error");
      }
    } catch (err) {
      console.error("Error creating project:", err);

      openNotification(err?.data?.message || "Failed to create project. Please try again.", "error");
    }

  };








  return (
    <>
      {/* Haeder */}
      <Headernp handleCancelClick={handleCancelClick} />

      {/*form Steps Start here */}
      <form onSubmit={formik.handleSubmit}>
        {activeStep === 0 &&
          <FirstStep formik={formik} handleClick={handleClick} handlePrevious={handlePrevious} activeStep={activeStep} steps={steps} iconList={iconList} />}
        {activeStep === 1 &&
          <SecondStep formik={formik} handleClick={handleClick} handlePrevious={handlePrevious} activeStep={activeStep} steps={steps} />}
        {activeStep === 2
          && <ThirdStep formik={formik} handleClick={handleClick} handlePrevious={handlePrevious} activeStep={activeStep} steps={steps} />}
        {activeStep === 3 &&
          <FourthStep formik={formik} handleClick={handleClick} handlePrevious={handlePrevious} activeStep={activeStep} steps={steps} />}
      </form>



    </>
  );
};

export default CreateProject;